import React, { useState } from 'react'
import { Button, Label, Rating } from 'semantic-ui-react'
import "./ratingSection.css";
import { useParams } from "react-router-dom";

export default function RatingSection({ t, handelOnSendingRating, handelOnIgnoreRating, options }) {
  const { swapId } = useParams();
  const [showOptions, setShowOptions] = useState(false)
  const [ableToSendRating, setAbleToSendRating] = useState(false)
  const [rating, setRating] = useState(0);
  const [active, setActive] = useState();
  const [selectedOption, setSelectedOption] = useState("");

  // console.log("options: ", options)

  const handleChangeOnRate = (e, { rating }) => {
    e.preventDefault()
    setRating(rating)
    if (rating < 5) {
      setShowOptions(true)
      setAbleToSendRating(false)
      setActive()
    }
    else {
      setShowOptions(false)
      setAbleToSendRating(true)
    }
  }
  const handleSelectOption = (option, key) => {
    setActive(key)
    setSelectedOption(option)
    setAbleToSendRating(true)
    // console.log("Selected: ", option)
  }
  return (
    <div style={{
      height: "100%",
      width: "100%",
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
    }}>
      <div style={{ margin: "0 auto" }}>
        <Rating maxRating={5} defaultRating={rating} icon='star' size='massive'
          value={rating}
          style={{ fontSize: "80px" }}
          onRate={handleChangeOnRate}
        />
      </div>

      {options && showOptions ?
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "space-evenly" }}>
          {options.map((item, key) => (
            <Button
              key={key}
              className={active == key ? "active" : null}
              circular
              onClick={() => handleSelectOption(item, key)}
              style={{
                fontSize: 20,
                border: 0,
                color: "black",
                // fontWeight: 25,
                // padding: "20px 30px",
                margin: 0
              }}
              content={t(item)}
            />
          ))}
        </div>
        : null}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
        <Label style={{
          fontSize: 20,
          color: "black",
          border: 0,
          textDecoration: "underline"
        }}
          basic={true}
          onClick={handelOnIgnoreRating}
        >{t("Finish without rating")}</Label>
        <Button
          style={{
            width: "250px",
            borderRadius: 50,
            backgroundColor: "#D8D8D8",
            fontSize: 20,
            color: "black",
            padding: 20,
            margin: 0
          }}
          className="send-button"
          disabled={!ableToSendRating}
          primary
          circular
          size="massive"
          content={t("Finish")}
          onClick={() => handelOnSendingRating({ rating, selectedOption, validation_hash_key: swapId })}
        />
      </div>

    </div>
  )
}
